'use client'

import {
  Box,
  Flex,
  Avatar,
  HStack,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Image,
  Stack,
} from '@chakra-ui/react'
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons'
import { ColorModeSwitcher } from '../ColorModeSwitcher';
import light from '../assets/Logolight.png'
import dark from '../assets/Logodark.png'
import { Link } from 'react-router-dom'


const Links = [
  { name: "MEN", id: "men" },
  { name: "WOMEN", id: "women" },
  { name: "ABOUT ", id: "about" },
  { name: "CONTACT ", id: "contact" },

];

const NavLink = (props) => {
  const { children } = props
  console.log(children)
  return (
    <Box
      as="a"
      px={2}
      py={1}
      rounded={'md'}
      _hover={{
        textDecoration: 'none',
        bg: useColorModeValue('gray.200', 'gray.700'),
      }}
      href={'#'}>
      {children}
    </Box>
  )
}

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Box position={'fixed'} w={'full'} zIndex={2} mt={'37px'} bg={useColorModeValue('gray.100', 'gray.900')} px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'} mx={[0, 10, 20, 30, 40]}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <Link to='/'>
              <Box>

                <Image src={useColorModeValue(light, dark)} mt={12} height={'360px'} />
              </Box>

            </Link>

            <HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
              {Links.map((link) => (
                <Link to={`/${link.id}`}>
                  <NavLink key={link.id}>{link.name}</NavLink>
                </Link>
              ))}
            </HStack>
          </HStack>
          <Flex alignItems={'center'}>

            <Menu>
              <MenuButton
                as={Button}
                rounded={'full'}
                variant={'link'}
                cursor={'pointer'}
                minW={0}>
                <Avatar
                  size={'sm'}
                  src={
                    'https://images.unsplash.com/photo-1493666438817-866a91353ca9?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
                  }
                />
              </MenuButton>
              <ColorModeSwitcher justifySelf="flex-end" />
              <MenuList>
                <MenuItem>Link 1</MenuItem>
                <MenuItem>Link 2</MenuItem>
                <MenuDivider />
                <MenuItem>Link 3</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
              {Links.map((link) => (
                <Link to={`/${link.id}`}>
                <NavLink key={link.id}>{link.name}</NavLink>
              </Link>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>


    </>
  )
}